<template>
  <div :style="getBtnStyle" class="vertical-group-wrapper">
    <div class="btn-group-vertical left-group" v-if="showSingleNaAll()">
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('TODAY')"
      >
        T
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('YESTERDAY')"
      >
        Y
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('L_WEEK')"
      >
        LW
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('MONTH')"
      >
        TM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('LAST_MONTH')"
      >
        LM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerNaAll('ALL')"
      >
        CUST
      </button>
      <button
          type="button"
          class="btn btn-light btn-tag-drop"
          @click="emitPresetTrigger(null)"
      >
        CAL
      </button>
    </div>
    <div
      class="btn-group-vertical single-group"
      v-if="
        multipleColumn
          ? CheckUserPermission([1, 2, 3, 4, 12]) && tag !== 'am'
          : true
      "
    >
      <!--    <div class="btn-group-vertical left-group">-->
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('TODAY')"
      >
        T
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('YESTERDAY')"
      >
        Y
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('L_WEEK')"
      >
        LW
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('MONTH')"
      >
        TM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('LAST_MONTH')"
      >
        LM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('ALL')"
      >
        ALL
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger(null)"
      >
        CAL
      </button>
    </div>
    <div
      class="btn-group-vertical single-group"
      v-if="tag === 'na' && CheckUserPermission([5, 7])"
    >
      <!--    <div class="btn-group-vertical left-group">-->
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('TODAY')"
      >
        T
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('YESTERDAY')"
      >
        Y
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('L_WEEK')"
      >
        LW
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('MONTH')"
      >
        TM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('LAST_MONTH')"
      >
        LM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTrigger('ALL')"
      >
        ALL
      </button>
      <button
          type="button"
          class="btn btn-light btn-tag-drop"
          @click="emitPresetTrigger(null)"
      >
        CAL
      </button>
    </div>
    <div
      class="btn-group-vertical right-group"
      v-if="
        multipleColumn &&
          CheckUserPermission([1, 2, 3, 4, 7, 12]) &&
          tag !== 'na'
      "
    >
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('TODAY')"
      >
        T
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('TOMORROW')"
      >
        ND
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('N_WEEK')"
      >
        NW
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('N_MONTH')"
      >
        NM
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('N_Q')"
      >
        NQ
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('N_Y')"
      >
        NY
      </button>
      <button
        type="button"
        class="btn btn-light btn-tag-drop"
        @click="emitPresetTriggerFuture('ALL')"
      >
        ALL
      </button>
      <button
          type="button"
          class="btn btn-light btn-tag-drop"
          @click="emitPresetTrigger(null)"
      >
        CAL
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "TagsDropdown",
  props: {
    btnColors: {
      type: Object
    },
    multipleColumn: {
      type: Boolean
    },
    tag: {
      type: String
    }
  },
  methods: {
    showSingleNaAll() {
      if (
        this.multipleColumn &&
        this.CheckUserPermission([1, 2, 3, 4, 12]) &&
        this.tag === "na"
      ) {
        return true;
      } else {
        return false;
      }
      //    multipleColumn && CheckUserPermission([1, 2, 3, 4, 7, 12]) && tag === 'na'
    },
    emitPresetTrigger(preset) {
      this.$emit("presetTrigger", preset);
    },
    emitPresetTriggerFuture(preset) {
      this.$emit("presetTriggerFuture", preset);
    },
    emitPresetTriggerNaAll(preset) {
      this.$emit("presetTriggerNaAll", preset);
    }
  },
  mixins: [UsersPermissionCheck],
  computed: {
    getBtnStyle() {
      return {
        "--bg-color": this.btnColors.backgroundColor,
        "--color": this.btnColors.color
      };
    }
  },
  mounted() {
    // this.getBtnStyle
  }
};
</script>

<style scoped lang="scss">
$bgColor: var(--bg-color);
$color: var(--color);
.btn-tag-drop {
  background-color: $bgColor;
  color: $color;
  font-size: 10px;
  padding: 3px 0px;
  margin-bottom: 1px;
}

.btn-tag-drop:hover {
  //opacity: 0.9;
  filter: brightness(95%);
}

.vertical-group-wrapper {
  display: flex;
}

.left-group,
.right-group {
  flex: 1;
  max-width: 50% !important;
}

.single-group {
  flex: 1;
  width: 100% !important;
}

.left-group .btn-tag-drop:last-child {
  border-radius: 0px 0px 0px 5px !important;
}

.left-group .btn-tag-drop:first-child {
  border-radius: 5px 0px 0px 0px !important;
}

.right-group .btn-tag-drop:last-child {
  border-radius: 0px 0px 5px 5px !important;
}

.right-group .btn-tag-drop:first-child {
  border-radius: 0px 5px 0px 0px !important;
}
</style>
